import React from "react";
import Field from "../ui/Field";
import AddressFields from "./AddressFields";

// Delivery address: "same as above" (a read-only line mirroring `aboveAddress`),
// or a separate structured address when unticked.
export default function DeliveryAddressField({
  sameAsAbove,
  onSameAsAboveChange,
  aboveAddress,
  value,
  onChange,
  protectedFetch,
  attempted = false,
  className,
}) {
  return (
    <Field label="Delivery address" className={className}>
      <label className="rma-nc-inline-checkbox">
        <input
          type="checkbox"
          checked={sameAsAbove}
          onChange={(event) => onSameAsAboveChange(event.target.checked)}
        />
        Same as above
      </label>
      {sameAsAbove ? (
        <input
          type="text"
          disabled
          value={aboveAddress}
          className="rma-nc-control rma-nc-control--md"
        />
      ) : (
        <AddressFields
          value={value}
          onChange={onChange}
          protectedFetch={protectedFetch}
          attempted={attempted}
        />
      )}
    </Field>
  );
}
